var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggle = function (on) {
            var next = on == undefined ? !_this.state.on : on;
            _this.setState({
                on: next,
            });
            utilSound.event(IdEventSoundCore.ButtonClick);
            return next;
        };
        return _this;
    }
    Toggle.prototype.componentWillMount = function () {
        var on = this.props.on;
        this.setState({
            on: on || false,
        });
    };
    Toggle.prototype.render = function () {
        var children = this.props.children;
        var on = this.state.on;
        return children(on, this.onToggle);
    };
    return Toggle;
}(React.PureComponent));
export { Toggle };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/toggle/Toggle.tsx
// module id = 969
// module chunks = 3